
export enum EPostType {
  SHARING_VENDOR = 'sharing_vendor',
  KNOWLEDGE = 'knowledge',
  KNOWLEDGE_REQUEST = 'knowledge_request',
}
